"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'BasicAvatar',
  props: {
    src: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {
      defaultAvatar: require('@/assets/images/avatar.png')
    };
  }
};